import { render, staticRenderFns } from "./time-board.vue?vue&type=template&id=44181279&scoped=true&"
import script from "./time-board.vue?vue&type=script&lang=js&"
export * from "./time-board.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44181279",
  null
  
)

export default component.exports